import { Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy ,  OnChanges, SimpleChanges, ChangeDetectorRef} from '@angular/core';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
@Component({
    selector: 'tab-list',
    templateUrl: './tab-list.template.html',
    styleUrls: ['./tab-list.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
  })
export class TabList {
    @Input() list: Array<any>;
    @Input() about : any;
    @Input() selectedTab: string;
    public subjects : Array<any> = [];
    private firstSub : Subscription;
    private routeSnapshotParams;
    
    
    constructor(
        protected coreEffects : CoreEffects,
        protected router: Router,
        protected route: ActivatedRoute,
        protected cd : ChangeDetectorRef
    ){

    }

    ngOnInit(){
        //console.log(this.list);
    }

    ngOnDestroy(){
        if( this.firstSub) {
            this.firstSub.unsubscribe();
            this.firstSub = null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/tab-list/tab-list.component.ts